
import { defineComponent, ref, computed } from 'vue'

import Token from '@web/common/token'
import { useStore } from '@web/store'

import AsExternalDocument from '@web/components/AsExternalDocument.vue'
import AcPoints from '@web/components.v2/AcPoints.vue'

export default defineComponent({
  components: {
    AcPoints,
    AsExternalDocument
  },
  setup () {
    const store = useStore()

    const menuOpen = ref(false)
    const user = computed(() => store.getters['user/user'])
    const username = computed(() => store.getters['user/username'])
    const logo = computed(() => store.getters['assets/logo'])
    const menu = computed(() => store.getters['menu/setting'])
    const userScoreAmount = computed(() => store.getters['userScore/amount'])
    const urlAdmin = computed(() => `/admin/login?token=${Token.get()}`)

    function closeMenu () {
      menuOpen.value = false
      document.body.removeEventListener('click', closeMenu)
    }

    function openMenu () {
      menuOpen.value = true
      document.body.addEventListener('click', closeMenu)
    }

    function toggleMenu () {
      if (menuOpen.value) {
        closeMenu()
      } else {
        openMenu()
      }
    }

    return {
      menuOpen,
      user,
      username,
      logo,
      menu,
      userScoreAmount,
      urlAdmin,

      toggleMenu
    }
  }
})
